import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRentalsLeases = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#f0d26e",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7875 14.9075H1.92932C1.37704 14.9075 0.929321 14.4598 0.929321 13.9075V7.97586C0.929321 7.42358 1.37704 6.97586 1.92932 6.97586H3.89513C4.44742 6.97586 4.89513 6.52815 4.89513 5.97586V2.30511C4.89513 1.66242 5.49267 1.18659 6.11904 1.3305L14.0114 3.14368C14.4656 3.24802 14.7875 3.65227 14.7875 4.11829V13.9075C14.7875 14.4598 14.3398 14.9075 13.7875 14.9075Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.22583 6.97266H5.7666C6.31889 6.97266 6.7666 7.42037 6.7666 7.97265L6.76662 13.9521",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8217 6.30737V11.7883",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.973877 10.9401H6.7666",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })
});
export default SvgRentalsLeases;
